import { useMutation } from "@apollo/client";

import { MapEditorObservationPanel_ObservationDeleteDocument } from "./mutations.generated";

export function useDeleteObservationMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationDeleteDocument);

    const deleteObservation = (mapEditorFeatureId: string) => {
        return mutate({
            variables: {
                input: {
                    featureId: mapEditorFeatureId,
                },
            },
        });
    };

    return [deleteObservation, result] as const;
}
